import { ReportReviewView } from "@api/graphql/types-and-hooks";
import { REVIEW_PARAM, REVIEW_PARAM_BY_VIEW, REVIEW_VIEWS } from "@components/ReportReview/reviewViews";

export const parseReviewParam = (value: string | null): ReportReviewView | undefined =>
  value ? REVIEW_VIEWS.find((view) => REVIEW_PARAM_BY_VIEW[view] === value) : undefined;

export const reviewParamFromView = (view: ReportReviewView): string => REVIEW_PARAM_BY_VIEW[view];

export const getReviewListPath = (view: ReportReviewView): string =>
  `/clinical-reports?${REVIEW_PARAM}=${reviewParamFromView(view)}`;
